import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "../components/PageHero";
import { StepFlow, CTASection } from "../components/Sections";
import { ComplianceBanner } from "../components/ComplianceBanner";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../data/config";

export default function Telemedicine() {
  const { t } = useTranslation();
  return (
    <>
      <PageHero
        overline={t("telemedicine.overline")}
        title={<>{t("telemedicine.titleA")} <span className="text-health">{t("telemedicine.titleAccent")}</span></>}
        subtitle={t("telemedicine.subtitle")}
        image={IMAGES.telemedicine}
        accent="health"
        testId="telemedicine-hero"
      />
      <StepFlow overline={t("telemedicine.flowOverline")} title={t("telemedicine.flowTitle")} accent="health" steps={t("telemedicine.steps", { returnObjects: true })} />
      <section className="pb-8">
        <div className="container-x"><Reveal><ComplianceBanner text={t("telemedicine.banner")} /></Reveal></div>
      </section>
      <CTASection title={t("telemedicine.ctaTitle")} subtitle={t("telemedicine.ctaSub")} ctaLabel={t("common.getQuote")} ctaTo="/quote" variant="gold" testId="telemedicine-cta" />
    </>
  );
}
